import * as React from 'react';
import 'react/jsx-runtime';
import { EGDSLayoutSizes } from '../../layout/types/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSLayoutFlexItemAlignSelfs, EgdsSizingLengths } from '../types/index.esm.js';
import styles from '../../styles/uitk-egds-layout-flex.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSLayoutFlexItem = props => {
  const {
    alignSelf,
    children,
    className,
    maxWidth,
    minWidth,
    grow,
    shrink,
    style
  } = props;
  /**
   * Check string is a valid EgdsSizingLength value
   *
   * @param size {string} - size
   * @returns EgdsSizingLengths.includes(size as EgdsSizingLength)
   */
  const IsEgdsSize = size => EgdsSizingLengths.includes(size);
  const childrenArray = React.Children.toArray(children);
  const firstChild = childrenArray[0];
  if (!firstChild || typeof firstChild !== 'object' || !('props' in firstChild)) {
    return null;
  }
  const firstChildClassName = firstChild.props.className;
  const firstChildStyle = firstChild.props.style;
  const baseClass = 'uitk-layout-flex-item';
  /**
   * Return a valid className for minWidth or maxWidth
   *
   * @param prop {typeof minWidth | typeof maxWidth} - prop
   * @param prefix {"flex-basis" | "max-width"} - className prefix
   * @returns string
   */
  const lengthClassName = (prop, prefix) => prop && typeof prop === 'string' && `${baseClass}-${prefix}-${IsEgdsSize(prop) ? prop : EGDSLayoutSizes.get(prop)}`;
  const wrapperClassNames = getClassNameList(alignSelf && `${baseClass}-${EGDSLayoutFlexItemAlignSelfs.get(alignSelf)}`, baseClass, firstChildClassName, lengthClassName(maxWidth, 'max-width'), lengthClassName(minWidth, 'flex-basis'), typeof grow !== 'undefined' && Number.isInteger(grow) && `${baseClass}-flex-grow-${grow}`, typeof shrink !== 'undefined' && Number.isInteger(shrink) && `${baseClass}-flex-shrink-${shrink}`, className);
  const wrapperStyle = {
    ...firstChildStyle,
    ...style,
    ...(minWidth && typeof minWidth === 'number' && {
      flexBasis: `${minWidth}px`
    }),
    ...(maxWidth && typeof maxWidth === 'number' && {
      maxInlineSize: `${maxWidth}px`
    })
  };
  const decoratedChild = React.cloneElement(firstChild, {
    className: wrapperClassNames,
    ...(Object.keys(wrapperStyle).length && {
      style: wrapperStyle
    })
  });
  return decoratedChild;
};
EGDSLayoutFlexItem.displayName = 'EGDSLayoutFlexItem';
export { EGDSLayoutFlexItem };